import { GsFormField } from '../../../components';

export const OPENING_HOURS_SCHEMA_FIELDS: GsFormField<never>[] = [
  {
    formControlName: 'showOpeningHours',
    label: 'components.openingHours.schema.showOpeningHours',
    type: 'checkbox',
    default: false,
    groupingName: 'components.openingHours.schema.group'
  },
  {
    formControlName: 'openingHoursTitle',
    label: 'components.openingHours.schema.title',
    type: 'text',
    nullable: true,
    groupingName: 'components.openingHours.schema.group',
    if: {
      chaining: 'and',
      args: [
        {
          formControlName: 'showOpeningHours',
          value: true
        },
        {
          formControlName: 'showOpeningHoursToday',
          value: false
        }
      ]
    }
  }
];
